

$('#headerBanner').click(function(event) {

    if (event.target.tagName == "A") {
        var category = event.currentTarget.id + "_" + event.currentTarget.outerText.replaceAll(" ", "_");
        var action = event.target.innerText.replaceAll(" ", "_");
        var label = event.target.href;

        Tms.link({
            category: category,
            action: action,
            label: label
        })
    }
});
